import { AfterContentChecked } from '@angular/core';
import { AfterViewChecked, AfterViewInit, Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from "lodash";
import { element } from 'protractor';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { CosignationPortsService } from 'src/app/Service/cosignation-ports.service';
import { SharedService } from 'src/app/Service/shared.service';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
declare var $: any


@Component({
  selector: 'app-consignation-ports',
  templateUrl: './consignation-ports.component.html',
  styleUrls: ['./consignation-ports.component.scss']
})
export class ConsignationPortsComponent implements OnInit {
  currentlang = '';
  currentUrl;
  outputLg;
  slick: any = null;
  isArab=false;
  langue;
  description;
  consignations : any;

  constructor(private global: Global, private service: CosignationPortsService, private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService){}

  ngOnInit(): void {

    console.log("consignations")
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;
      this.shared.getBlocDescriptionByCode(lg.url, "consignation_ports").subscribe(data => {
        this.description = data["value"][0];
      })

      this.service.getConsignations().subscribe(data => {
        this.consignations = data;
        this.consignations = this.consignations.sort(function (a, b) {
          return a.OrdreTrie - b.OrdreTrie;
        });
        this.ShowConsignations()
      });
      
    });

    

    
  }
   ShowConsignations() {
    console.log("Show consignations")
    console.log(this.consignations)
  }
  
}

